import React, { useState, useEffect } from 'react';
import { client } from '../prismic-configuration';

import styles from '../components/article/article-content.module.scss';
import ArticleContent from '../components/article/ArticleContent';

import SEO from '../components/_globals/seo/SEO';
import { Redirect } from 'react-router-dom';
import { RichText } from 'prismic-reactjs';

import * as ROUTES from '../constants/routes';

const PageArticle = ({ match }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
      const fetchData = async () => {
        const paramFromUrl = match.params.id;
        const response = await client.getByUID('article', paramFromUrl);
        if (response) {
          setData(response.data)
        } else {
            setError(true);
        }
      }
      fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    if (error) {
        return <Redirect to={ROUTES.LANDING}/>
    }
    
    if (data === null) {
        return null;
    }

    return (
        <>
            <SEO title={RichText.asText(data.title)}/>

            <div className={styles['page-content']}>
                <ArticleContent {...data}/>
            </div>
        </>
    )
}

export default PageArticle;